import { useContext } from 'react';
import { DpvaleSelectedContext } from '@/data/context/dpvale';

export const useDpvaleSelected = () => {
	const context = useContext(DpvaleSelectedContext);

	if (!context) {
		throw new Error('useDpvaleSelected must be used within a DpvaleSelectedProvider');
	}

	return context;
};
